import api from './apiClient';

export const registrationsAPI = {
  getRegistrations: async () => {
    const response = await api.get('/api/registrations');
    return response.data;
  },
  getRaceRegistrations: async (raceId) => {
    const response = await api.get('/api/races/' + raceId + '/registrations');
    return response.data;
  },
  createRegistration: async (registrationData) => {
    const response = await api.post('/api/registrations', registrationData);
    return response.data;
  },
  getRegistrationById: async (id) => {
    const response = await api.get('/api/registrations/' + id);
    return response.data;
  },
  deleteRegistration: async (id) => {
    await api.post('/api/registrations/' + id + '/delete', {});
  },
  confirmRegistration: async (id, paymentStatus) => {
    const response = await api.post('/api/registrations/' + id + '/confirm', { paymentStatus });
    return response.data;
  },
  publicConfirmRegistration: async (id, paymentStatus) => {
    const response = await api.post('/api/registrations/' + id + '/confirm-payment', { paymentStatus });
    return response.data;
  },
  updateBibNumber: async (id, bibNumber) => {
    const response = await api.post('/api/registrations/' + id + '/bib-number', { bibNumber });
    return response.data;
  },
  markBibPickedUp: async (id) => {
    const response = await api.post('/api/registrations/' + id + '/bib-pickup', {});
    return response.data;
  },
  importRegistrations: async (file: File, options?: { dryRun?: boolean; columnMap?: Record<string, string>; valueMap?: Record<string, Record<string, string>>; columnsOnly?: boolean; raceId?: string; excludeRows?: number[] }) => {
    const formData = new FormData();
    formData.append('file', file);
    if (options?.dryRun) formData.append('dryRun', 'true');
    if (options?.columnsOnly) formData.append('columnsOnly', 'true');
    if (options?.raceId) formData.append('raceId', options.raceId);
    if (options?.excludeRows && options.excludeRows.length > 0) {
      formData.append('excludeRows', JSON.stringify(options.excludeRows));
    }
    if (options?.columnMap && Object.keys(options.columnMap).length > 0) {
      formData.append('columnMap', JSON.stringify(options.columnMap));
    }
    if (options?.valueMap && Object.keys(options.valueMap).length > 0) {
      formData.append('valueMap', JSON.stringify(options.valueMap));
    }
    const response = await api.post('/api/registrations/import', formData, {
      headers: { 'Content-Type': undefined },
    });
    return response.data;
  },
  cmsCreateRegistration: async (data: any) => {
    const response = await api.post('/api/registrations/cms-create', data);
    return response.data;
  },
  updateRegistration: async (id: any, data: any) => {
    const response = await api.post('/api/registrations/' + id + '/update', data);
    return response.data;
  },
};
